import React from 'react';
import { Flex, Heading } from 'rebass/styled-components';
import * as Yup from 'yup';
import TextInput, { TextInputWithLabel } from '../../../../components/TextInput';
import { Form, Formik } from 'formik';
import FormField from '../../../../components/FormField';
import { EditModalButtons } from '../EditModalButtons';
import { IBuilderCtrlProps } from '../types';

export const RangeInputEdit: React.FC<IBuilderCtrlProps> = ({ close, save, properties }) => {
  const schema = Yup.object().shape({
    question: Yup.string()
      .trim()
      .min(2, 'Question must be greater than 1 character')
      .required('Required'),
    researchId: Yup.string()
      .trim()
      .matches(/^[a-zA-Z0-9_]+$/, 'No special characters or space allowed except underscore (_)')
      .nullable(),
  });
  return (
    <Flex flex={1} flexDirection={'column'} width={'600px'}>
      <Heading textAlign={'center'} mb={4}>
        Edit Range
      </Heading>
      <Formik
        initialValues={{ ...properties }}
        isInitialValid={() => {
          try {
            const aa = schema.isValidSync({
              ...properties
            });

            return aa
          } catch (err) {
            return false;
          }
        }}
        validationSchema={schema}
        onSubmit={(values, actions) => {
          // let min =0
          // if()
          save(values);
        }}
        render={({ touched, errors, isValid, values, submitForm }) => (
          <Form>
            <FormField mb={3} error={touched.question && errors.question}>
              <TextInputWithLabel disabled={!properties.isHealthCoachCreated} placeholder="Question *" name="question" id="input_question" />
            </FormField>
            <FormField mb={3} error={touched.description && errors.description}>
              <TextInputWithLabel placeholder="description" name="description" id="input_description" />
            </FormField>
            <FormField mb={3} error={(touched.ctrlProps || {} as any).min && (errors.ctrlProps || {} as any).min}>
              <TextInputWithLabel disabled={!properties.isHealthCoachCreated} type="number" placeholder="minimum value" name="ctrlProps.min" id="input_min" />
            </FormField>
            <FormField mb={3} error={(touched.ctrlProps || {} as any).max && (errors.ctrlProps || {} as any).max}>
              <TextInputWithLabel disabled={!properties.isHealthCoachCreated} type="number" placeholder="maximum value" name="ctrlProps.max" id="input_max" />
            </FormField>
            {/* <FormField mb={3} error={touched.researchId && errors.researchId}>
              <TextInputWithLabel disabled={!properties.isHealthCoachCreated} placeholder="research Id (if set, data can be used for data analysis)" name="researchId" id="input_researchId" />
            </FormField> */}
            {!properties.isHealthCoachCreated && (
              <FormField
                flexDirection="row"
                mb={3}
                style={{
                  alignContent: 'center',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
                error={touched.mustBeInherited && errors.mustBeInherited}
              >
                <TextInput type="checkbox" checked={values.mustBeInherited} id={`mustBeInherited`} disabled={true} name="mustBeInherited" />
                <label htmlFor="mustBeInherited" style={{ marginLeft: '16px' }}>
                  must be inherited (templates created from this one will mandatorily have this item)
                </label>
              </FormField>
            )}
            <EditModalButtons
              close={close}
              save={submitForm}
              isValid={
                isValid &&
                !isNaN((values.ctrlProps || {} as any).min) &&
                !isNaN((values.ctrlProps || {} as any).max) &&
                (values.ctrlProps || {} as any).min < (values.ctrlProps || {} as any).max
              }
            />
          </Form>
        )}
      />
    </Flex>
  );
};
